import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";

function DeleteExpense() {
  const [expense, setExpense] = useState();
  const [isLoading, setIsLoading] = useState(true);

  let { eid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/expenses/${eid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setExpense(response.data.expense);
      setIsLoading(false);
    }
    fetch();
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/expenses/${eid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/expenses");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="delete-expense">
        <Col>
          <h4>Eliminar egreso</h4>
        </Col>
        <Col className="delete-expense-form">
          <Col className="mb-3">
            <p>{`Estas por eliminar el egreso. Una vez eliminado no podrás recuperar su información. ¿Estás seguro?`}</p>
          </Col>
          <Col>
            <Button variant="info" onClick={handleSubmit}>
              Eliminar
            </Button>
            <Button variant="danger" onClick={() => navigate("/expenses")}>
              Cancelar
            </Button>
          </Col>
        </Col>
      </Col>
    );
  }
}

export default DeleteExpense;
